import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SocialMediaSection = ({ 
  formData, 
  errors, 
  onChange 
}) => {
  const socialPlatforms = [
    { name: 'vkUrl', label: 'ВКонтакте', icon: 'Share2', placeholder: 'https://vk.com/yourpage' },
    { name: 'telegramUrl', label: 'Telegram', icon: 'Send', placeholder: 'https://t.me/yourpage' },
    { name: 'instagramUrl', label: 'Instagram', icon: 'Instagram', placeholder: 'https://instagram.com/yourpage' },
    { name: 'facebookUrl', label: 'Facebook', icon: 'Facebook', placeholder: 'https://facebook.com/yourpage' },
    { name: 'youtubeUrl', label: 'YouTube', icon: 'Youtube', placeholder: 'https://youtube.com/@yourpage' },
    { name: 'whatsappUrl', label: 'WhatsApp', icon: 'MessageCircle', placeholder: 'https://wa.me/79991234567' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
          Социальные сети
        </h3>
        <p className="text-sm text-text-secondary mb-6">
          Добавьте ссылки на ваши профили в социальных сетях
        </p>
      </div>
      <div className="space-y-4">
        {socialPlatforms?.map((platform) => (
          <div key={platform?.name} className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0 mt-1">
              <Icon name={platform?.icon} size={20} className="text-primary" />
            </div>
            <div className="flex-1">
              <Input
                label={platform?.label}
                type="url"
                name={platform?.name}
                placeholder={platform?.placeholder}
                value={formData?.[platform?.name]}
                onChange={onChange}
                error={errors?.[platform?.name]}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="bg-muted p-4 rounded-lg">
        <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Eye" size={16} />
          Предварительный просмотр
        </h4>
        <div className="flex flex-wrap gap-2">
          {socialPlatforms?.map((platform) => (
            formData?.[platform?.name] && (
              <a
                key={platform?.name}
                href={formData?.[platform?.name]}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-primary hover:bg-secondary transition-colors flex items-center justify-center"
                aria-label={platform?.label}
              >
                <Icon name={platform?.icon} size={20} color="#FFFFFF" />
              </a>
            )
          ))}
          {!socialPlatforms?.some(p => formData?.[p?.name]) && (
            <p className="text-sm text-text-secondary">
              Добавьте ссылки, чтобы увидеть иконки
            </p>
          )}
        </div>
      </div>
      <div className="bg-accent/10 p-4 rounded-lg flex items-start gap-3">
        <Icon name="Info" size={20} className="text-accent flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-sm font-medium text-foreground">Совет</p>
          <p className="text-xs md:text-sm text-text-secondary">
            Иконки социальных сетей будут отображаться в футере вашего сайта. Заполните только те поля, которые вы используете.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaSection;